/**
 * 输入的值
 * @param {} value
 * @param {*} attr
 */
import i18n from '@/i18n/index'
import _ from 'lodash'
import format from 'string-format'

const range = (param) => {
  return (rule, value, callback) => {
    if (value >= _.toNumber(param[0]) && value <= _.toNumber(param[1])) {
      callback()
      return
    }
    let msg = format(i18n.t(`validateMessage.E00000022`), param[0], param[1])
    callback(new Error(msg))
  }
}
export default range
